<script>
	import { mapMutations,mapState } from 'vuex';
	import {stepStepsTarget} from '../stepsTargets.js';

	export default{
		props:['stepActive'],
		data(){
			return{
				steps: stepStepsTarget,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Aceptar'
					}
				},
				myCallbacks: {
					onStop: this.myCustomStopCallback
				}
			}
		},
		computed:{
			...mapState(['alertas']),
		},
		mounted(){
			if(this.stepActive == 2 && this.alertas){
				this.$tours['noteInformacionGeneral'].start();
			}
		},
		methods:{
			...mapMutations(['changeStepActive']),
			myCustomStopCallback(){
				this.$emit('startTwoTour',true);
			}
		}
	}
</script>
<template>
	<div>
		<v-tour name="noteInformacionGeneral" :steps="steps" :options="myOptions" :callbacks="myCallbacks"/>

		<div class="steps">
			<div class="container-conector">
				<hr class="conector">
			</div>
			<div :class="{'step-active':stepActive == 1}">
				<span @click="changeStepActive(1)">1</span>
				Tipo de Solicitud
			</div>
			<div data-v-step="6" :class="{'step-active':stepActive == 2}">
				<span @click="changeStepActive(2)">2</span>
				Información General
			</div>
			<div :class="{'step-active':stepActive == 3}">
				<span @click="changeStepActive(3)">3</span>
				Aportación
			</div>
			<div :class="{'step-active':stepActive == 4}">
				<span @click="changeStepActive(4)">4</span>
				Aprobadores
			</div>
			<div :class="{'step-active':stepActive == 5}">
				<span @click="changeStepActive(5)">5</span>
				Adjuntos
			</div>
			<div :class="{'step-active':stepActive == 6}">
				<span @click="changeStepActive(6)">6</span>
				Revisar y Aprobar
			</div>
		</div>
	</div>
</template>